<template>
  <div class="work-component-block">
    <!-- Main components -->

    <TopPanel></TopPanel>
    <LeftPanel></LeftPanel>
    <CenterPanel></CenterPanel>

    <RightPanel></RightPanel>
    <BottomPanel></BottomPanel>

    <!-- Overlay modal windows -->
    <RendersPreviewWindow
      v-show="this.$store.getters.showRendersPreviewWindow"
      @close="onCloseRendersPreviewWindow"
    ></RendersPreviewWindow>

    <MusicLibraryWindow
      v-if="this.$store.getters.showMusicLibraryWindow"
      @close="onCloseMusicLibraryWindow"
    ></MusicLibraryWindow>

    <EndCardLibraryWindow
      v-if="this.$store.getters.showEndCardLibraryWindow"
      @close="onCloseEndCardLibraryWindow"
    ></EndCardLibraryWindow>

    <EndCardEditWindow
      v-if="this.$store.getters.showEndCardEditWindow"
      :packshot="packshotToEdit"
      @close="onCloseEndCardEditWindow"
    ></EndCardEditWindow>
  </div>
</template>

<script>
import "@/app/store/index";
import { $eventsBus } from "@/main";
import TopPanel from "@/app/modules/work/components/top-panel/TheTopPanel";
import LeftPanel from "@/app/modules/work/components/left-panel/TheLeftPanel";
import CenterPanel from "@/app/modules/work/components/center-panel/TheCenterPanel";
import RightPanel from "@/app/modules/work/components/right-panel/TheRightPanel";
import BottomPanel from "@/app/modules/work/components/bottom-panel/TheBottomPanel";
import RendersPreviewWindow from "@/app/modules/work/components/windows/RendersPreviewWindow";
import MusicLibraryWindow from "@/app/modules/work/components/windows/MusicLibraryWindow";
import EndCardLibraryWindow from "@/app/modules/work/components/windows/EndCardLibraryWindow";
import EndCardEditWindow from "@/app/modules/work/components/windows/EndCardEditWindow";

export default {
  name: "Work",
  components: {
    TopPanel,
    LeftPanel,
    CenterPanel,
    RightPanel,
    BottomPanel,
    RendersPreviewWindow,
    MusicLibraryWindow,
    EndCardLibraryWindow,
    EndCardEditWindow,
  },
  data: function () {
    return {
      savingInProgress: false,
      lastSavedJSONState: "",
      packshotToEdit: null,
    };
  },
  mounted() {
    $eventsBus.$emit("updateUserWorkspace");
    /*     if (this.$store.getters.isLoggedIn) {
      let ymUID = this.$cookies.get("_ym_uid");
      this.axios
        .post(
          "/user/getUser",
          { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.$store.state.userInfo.id = response.data.id;
          this.$store.state.userInfo.firstName = response.data.firstName;
          this.$store.state.userInfo.lastName = response.data.lastName;
          this.$store.state.userInfo.avatar = response.data.avatar;
          this.$store.state.userInfo.stockAccess = response.data.stockAccess;
          this.$store.state.userInfo.isSaveOriginalName =
            response.data.originalName;
          this.$store.state.userInfo.lastWorkspaceSaveTime =
            response.data.lastSaveWS;
          this.$router.push("/");
          $eventsBus.$emit("updateUserWorkspace", response.data.workspace);
        })
        .catch((erorr) => {
          console.error(erorr);
          this.$store.state.userInfo.sessionId = null;
          this.$router.push("/login");
        });
    } */
  },
  created() {
    $eventsBus.$on("saveUserWorkspace", (isForceSaving) => {
      this.requestSaving(isForceSaving);
    });
    $eventsBus.$on("updateUserWorkspace", (workspace) => {
      /*       if (!workspace) {
        return;
      }
	  let state = workspace; */
      let state = JSON.parse(window.localStorage.getItem("workspace"));
      this.$store.commit("updateStateByUserWorkspace", state);
      $eventsBus.$emit("updateAllMoveables");
    });
    $eventsBus.$on("openEndCardEditWindow", (endCardToEdit) => {
      this.packshotToEdit = endCardToEdit;
      this.$store.commit("showEndCardEditWindow", true);
      this.$store.commit("showEndCardLibraryWindow", false);
    });

    setInterval(() => {
      this.requestSaving();
    }, 10000);
  },
  methods: {
    onCloseRendersPreviewWindow() {
      this.$store.commit("showRendersPreviewWindow", false);
    },
    onCloseMusicLibraryWindow() {
      this.$store.commit("showMusicLibraryWindow", false);
    },
    onCloseEndCardLibraryWindow() {
      this.$store.commit("showEndCardLibraryWindow", false);
    },
    onCloseEndCardEditWindow() {
      this.$store.commit("showEndCardEditWindow", false);
      this.$store.commit("showEndCardLibraryWindow", true);
    },
    onCloseStickerLibraryWindow() {
      this.$store.commit("showStickerLibraryWindow", false);
    },
    onCloseOverlaysLibraryWindow() {
      this.$store.commit("showOverlaysLibraryWindow", false);
    },
    checkServerWorkspaceChangesAndSave() {
      let ymUID = this.$cookies.get("_ym_uid");
      this.axios
        .post(
          "/user/getUser",
          { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (
            this.$store.state.userInfo.lastWorkspaceSaveTime &&
            this.$store.state.userInfo.lastWorkspaceSaveTime <
              response.data.lastSaveWS
          ) {
            location.reload();
          } else {
            this.saveUserWorkspace();
          }
        })
        .catch((erorr) => {
          console.error(erorr);
          this.$store.state.userInfo.sessionId = null;
          this.$router.push("/login");
        });
    },
    requestSaving(isForceSaving = false) {
      let stateToParse = {
        variationNamingTemplate: this.$store.state.variationNamingTemplate,
        items: this.$store.state.items,
        mixedParts: this.$store.state.mixedParts,
        renderItems: this.$store.state.renderItems,
        muted: this.$store.state.muted,
        showDownloadPanel: this.$store.state.showDownloadPanel,
        audioParameters: this.$store.state.audioParameters,
      };
      //let cache = [];
      let state = JSON.stringify(stateToParse, (key, value) => {
        /* if (key === "parentItem") {
          return null;
        } */
        /*         if (typeof value === "object" && value !== null) {
          // Duplicate reference found, discard key
          if (cache.includes(value)) {
            return;
          }

          // Store value in our collection
          cache.push(value);
        } */
        return value;
      });
      window.localStorage.setItem("workspace", state);
      return;
      if (this.savingInProgress) {
        setTimeout(() => {
          this.requestSaving(isForceSaving);
        }, 1000);
      } else {
        if (isForceSaving) {
          this.saveUserWorkspace();
        } else {
          this.checkServerWorkspaceChangesAndSave();
        }
      }
    },
    saveUserWorkspace() {
      this.savingInProgress = true;
      // Сохранение происходит:
      // - Каждые 30 секунд
      // - При каждом удалении, добавлении, восстановлении файлов или вариаций
      // - При каждой отправке на рендер и изменении в боковой панели рендера
      console.log("Save workspace");
      let stateToParse = {
        variationNamingTemplate: this.$store.state.variationNamingTemplate,
        items: this.$store.state.items,
        renderItems: this.$store.state.renderItems,
        muted: this.$store.state.muted,
        showDownloadPanel: this.$store.state.showDownloadPanel,
      };
      //let cache = [];
      let state = JSON.stringify(stateToParse, (key, value) => {
        /* if (key === "parentItem") {
          return null;
        } */
        /*         if (typeof value === "object" && value !== null) {
          // Duplicate reference found, discard key
          if (cache.includes(value)) {
            return;
          }

          // Store value in our collection
          cache.push(value);
        } */
        return value;
      });
      if (this.lastSavedJSONState === state) {
        this.savingInProgress = false;
        console.log("No need to save workspace");
        return;
      } else {
        this.lastSavedJSONState = state;
      }
      //cache = null;
      this.axios
        .post(
          "/user/setWorkspace",
          {
            sessionId: this.$store.state.userInfo.sessionId,
            workspace: JSON.parse(state),
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Workspace saved");
          this.$store.state.userInfo.lastWorkspaceSaveTime =
            response.data.currentTime;
          this.savingInProgress = false;
        })
        .catch((erorr) => {
          console.error(erorr);
          console.log("Workspace not saved");
          this.savingInProgress = false;
        });
    },
  },
};
</script>

<style lang="scss">
.work-component-block {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
